import { DropzoneFile } from 'dropzone';
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDropzone } from '../state/useDropzone';
import { DropzoneOptionLabels } from '../state/dropzoneOptions';
import { ImageUploadResponse } from '../types';

export type ImageDropzoneLabels = {
    filesAdded: string;
} & DropzoneOptionLabels;

type ImageDropzoneProps = {
    labels: ImageDropzoneLabels;
    orderId: number;
    filesAdded: DropzoneFile[];
    formAction: string;
    addFile: (file: DropzoneFile) => void;
    removeFile: (file: DropzoneFile) => void;
    formId: string;
    onUpload: (formData: FormData) => Promise<number[]>;
    setImageInProgress: (imageUploadResponse: ImageUploadResponse) => void;
    onRetryUpload: () => void;
};

export function ImageDropzone({
    labels,
    formAction,
    formId,
    filesAdded,
    addFile,
    removeFile,
    orderId,
    onUpload,
    setImageInProgress,
    onRetryUpload
}: ImageDropzoneProps) {
    let optionLabels: DropzoneOptionLabels = {
        defaultMessage: labels.defaultMessage,
        fallbackMessage: labels.fallbackMessage,
        invalidFileType: labels.invalidFileType,
        cancelUpload: labels.cancelUpload,
        cancelUploadConfirmation: labels.cancelUploadConfirmation
    };

    let dropzone = useDropzone(
        formId,
        addFile,
        removeFile,
        setImageInProgress,
        onRetryUpload,
        optionLabels
    );

    let formRef = React.useRef<HTMLFormElement | null>(null);

    return (
        <Box sx={{ paddingBottom: '20px' }}>
            <form
                ref={formRef}
                action={formAction}
                id={formId}
                className="dropzone dropzone-custom"
                onSubmit={(event) => {
                    event.preventDefault();
                    let formData = new FormData(formRef.current);

                    let files = filesAdded.map((file) => file.name).join(',');
                    formData.set('files', files);

                    onUpload(formData).then(() => {
                        if (!dropzone.current) {
                            return;
                        }

                        let queuedFiles = dropzone.current.getQueuedFiles();
                        if (queuedFiles.length > 0) {
                            dropzone.current.processQueue();
                        }
                    });
                }}
            >
                <input type="hidden" name="orderId" value={orderId} />
            </form>
        </Box>
    );
}
